/* eslint-disable prettier/prettier */
import { Redirect, RouteComponentProps } from "@reach/router"
import { useEffect } from "react"
import { FullPageLoader } from "@shared/primitive-components"
import { useAuth } from "../../contexts"

// --------------------------------------------------------------------------------------------------------------------

export const Login: React.FC<RouteComponentProps> = () => {
  const { isAuthenticated, isLoading, login, getAuthType, isAuthenticated: isAuthServiceAuthenticated } = useAuth()

  useEffect(() => {
    ;(async () => {
      if (!isAuthenticated && !isLoading) {
        login({ email: ``, password: `` })
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isLoading])

  if (isAuthServiceAuthenticated && !isLoading) {
    return <Redirect to={getAuthType() !== `customer` ? `/policies` : `/fleet`} />
  }

  return <FullPageLoader />
}
